// Frontend mirror of the backend expiry logic
// (backend/src/alerts/thresholds.js). Keep the colour bands and thresholds
// in sync across both files.

export const THRESHOLDS = [1, 7, 15, 30, 60, 90];

export function daysUntil(dateStr) {
  if (!dateStr) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const target = new Date(dateStr);
  if (Number.isNaN(target.getTime())) return null;
  target.setHours(0, 0, 0, 0);
  return Math.round((target - today) / (1000 * 60 * 60 * 24));
}

// Four colour bands: green (safe) → yellow → orange → red (critical).
export function colorForDays(daysLeft) {
  if (daysLeft === null || daysLeft === undefined) {
    return {
      level: "none",
      label: "Unknown",
      hex: "#94a3b8",
      bg: "rgba(148, 163, 184, 0.12)",
    };
  }
  if (daysLeft <= 7)
    return {
      level: "red",
      label: "Critical",
      hex: "#ef4444",
      bg: "rgba(239, 68, 68, 0.12)",
    };
  if (daysLeft <= 30)
    return {
      level: "orange",
      label: "Urgent",
      hex: "#f97316",
      bg: "rgba(249, 115, 22, 0.12)",
    };
  if (daysLeft <= 60)
    return {
      level: "yellow",
      label: "Warning",
      hex: "#f59e0b",
      bg: "rgba(245, 158, 11, 0.12)",
    };
  return {
    level: "green",
    label: "Healthy",
    hex: "#10b981",
    bg: "rgba(16, 185, 129, 0.12)",
  };
}

export function actionForDays(daysLeft) {
  if (daysLeft === null || daysLeft === undefined) return "Set an expiry date";
  if (daysLeft < 0) return "Expired — Renew Immediately";
  if (daysLeft <= 7) return "Renew Immediately";
  if (daysLeft <= 15) return "Renew Urgently";
  if (daysLeft <= 30) return "Renew Soon";
  if (daysLeft <= 60) return "Plan Renewal";
  return "Schedule Renewal";
}

// "7 Days" / "Expired 3 days ago"
export function expiresInLabel(daysLeft) {
  if (daysLeft === null || daysLeft === undefined) return "—";
  if (daysLeft < 0) {
    const n = Math.abs(daysLeft);
    return `Expired ${n} day${n === 1 ? "" : "s"} ago`;
  }
  return `${daysLeft} Day${daysLeft === 1 ? "" : "s"}`;
}
